import React, { useEffect } from 'react';
import { Grid } from 'ldrs/react';
import 'ldrs/react/Grid.css';
import heroPoster from '../assets/Hero-poster.svg';

const LoadingSpinner = () => {
  useEffect(() => {
    // Ensure ldrs is properly initialized
    if (typeof window !== 'undefined') {
      // Small delay to ensure proper mounting
      const timer = setTimeout(() => {
        // Component should be fully rendered by now
      }, 50);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      width: '100%',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      backgroundImage: `url(${heroPoster})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundAttachment: 'fixed',
      zIndex: 9999
    }}>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        backdropFilter: 'blur(1px)'
      }}></div>
      <div style={{
        position: 'relative',
        zIndex: 1
      }}>
        <Grid
          size="60"
          speed="1.5"
          color="white"
        />
      </div>
    </div>
  );
};

export default LoadingSpinner; 